import { Link } from 'react-router-dom'
import { client } from '../../hooks/Client'
import useDeccaConversations from '../../hooks/decca/useDeccaConversations'
import formatConversationDate from '../../helpers/decca/formatConversationDate'
import Table from '../common/table/Table'
import TableCell from '../common/table/TableCell'
import StaticCardLabel from './StaticCardLabel'
import DashboardCardEmptyState from './DashboardCardEmptyState'

// AI-CONTEXT: See docs/patterns.md#dashboard-static-card
// AI-CONTEXT: See docs/features/decca-gesprekken-overzicht.md

const DECCOS_MANAGEMENT_TENANT = '123423HJKHVKH'

const RECENTE_GESPREKKEN = 5

const columns = [
    { key: 'organisation', label: 'ORGANISATIE' },
    { key: 'title', label: 'GESPREK' },
    { key: 'date', label: 'DATUM', searchable: false },
]

/**
 * De laatste gesprekken die organisaties met Decca voerden, over alle
 * organisaties heen. Nieuwste bovenaan; een rij opent het hele gesprek.
 *
 * De gegevens komen van een Cloud Function: `Conversations` is in de
 * Firestore-regels per organisatie afgeschermd, dus de browser van de
 * beheertenant mag ze niet rechtstreeks lezen.
 */
const DashboardDeccaConversationsCard = () => {

    // Dezelfde poort als de zichtbaarheidsregel in staticCardRegistry. De
    // callable weigert een andere organisatie sowieso; dit voorkomt alleen dat
    // we hem voor niets bellen.
    const isManagementTenant = client === DECCOS_MANAGEMENT_TENANT

    const { rows, loading, error } = useDeccaConversations(RECENTE_GESPREKKEN, isManagementTenant)

    // 'Nog geen gesprekken' is een bewering aan de lezer, en die mag pas als de
    // gegevens er echt zijn. Let op: de Table draagt met `emptyMessage` een
    // TWEEDE lege toestand — die zit achter dezelfde poort.
    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    const geladen = Array.isArray(rows)
    const isLeeg = geladen && rows.length === 0

    return (
        <div>
            <StaticCardLabel
                title='Gesprekken met Decca'
                pill={{ variant: 'msi', label: 'Deccos' }}
            />

            {error ? (
                <p className='score-explain-card__placeholder'>{error}</p>
            ) : loading || !geladen ? (
                <p className='score-explain-card__placeholder'>Laden…</p>
            ) : isLeeg ? (
                <DashboardCardEmptyState type='decca-conversations' />
            ) : (
                <>
                    <Table
                        columns={columns}
                        items={rows}
                        getItemKey={(row) => row.id}
                        showSearch={false}
                        emptyMessage='Geen gesprekken gevonden.'
                        renderRow={(row) => (
                            <>
                                <TableCell>{row.communityName || 'Onbekende organisatie'}</TableCell>
                                <TableCell>
                                    <Link to={`/${client}/deccagesprekken/${row.id}`}>
                                        {row.title || 'Gesprek zonder titel'}
                                    </Link>
                                </TableCell>
                                <TableCell>{formatConversationDate(row.timestampMs)}</TableCell>
                            </>
                        )}
                    />
                    <p className='decca-conversations-card__all'>
                        <Link to={`/${client}/deccagesprekken`}>Alle gesprekken bekijken</Link>
                    </p>
                </>
            )}
        </div>
    )
}

export default DashboardDeccaConversationsCard
